import { jsx } from 'react/jsx-runtime';
import { useState, useCallback, useEffect } from 'react';
import { PrimaryButton } from '@zooplus/ui-components';
import { PAYMENT_SAVE_BUTTON_ID } from '../../../config/consts.js';
import { useFormSubmit } from '../../../hooks/useFormSubmit.js';
import { useTranslation } from '../../../hooks/useTranslations.js';
import { usePaymentContext } from '../../../providers/PaymentContextProvider.js';
import styles from './ContinueToDeliveryButton.module.scss.js';

const ContinueToDeliveryButton = () => {
    const { t } = useTranslation();
    const { checkoutState, selectedPayment, updateSelectedPayment } = usePaymentContext();
    const [isButtonClicked, setIsButtonClicked] = useState(false);
    const { paymentMessages, isPaymentLoading, setIsPaymentCollapsed } = checkoutState || {};
    const [submitFn] = useFormSubmit();
    const onContinueDelivery = useCallback(async () => {
        const paymentMethod = selectedPayment?.paymentMethodShortName || '';
        await submitFn(paymentMethod, () => {
            updateSelectedPayment({
                paymentMethod: selectedPayment?.paymentMethod || null,
                paymentMethodShortName: selectedPayment?.paymentMethodShortName || null,
                ...(selectedPayment?.details && { details: selectedPayment?.details }),
            });
        });
        setIsButtonClicked(true);
    }, [selectedPayment, submitFn, setIsButtonClicked, updateSelectedPayment]);
    useEffect(() => {
        if (!isPaymentLoading && paymentMessages?.length === 0 && isButtonClicked) {
            setIsPaymentCollapsed?.(true);
            setIsButtonClicked(false);
        }
    }, [isPaymentLoading, paymentMessages]);
    return (jsx(PrimaryButton, { className: styles.continueToDelivery, isLoading: isPaymentLoading, onClick: onContinueDelivery, id: PAYMENT_SAVE_BUTTON_ID, "data-zta": PAYMENT_SAVE_BUTTON_ID, children: t('checkout.preview.continueToDelivery') }));
};

export { ContinueToDeliveryButton };
//# sourceMappingURL=ContinueToDeliveryButton.js.map
